
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#F7BC00"}}),_c('path',{attrs:{"d":"M15.218 11.273h-1.556a1.521 1.521 0 00-.174-.536 1.365 1.365 0 00-.337-.405 1.486 1.486 0 00-.476-.255 1.82 1.82 0 00-.579-.09c-.376 0-.704.094-.983.281-.28.185-.496.455-.65.81-.154.353-.231.781-.231 1.286 0 .518.077.954.23 1.306.157.353.375.62.654.8.28.18.603.27.97.27.206 0 .396-.028.571-.082a1.37 1.37 0 00.813-.625c.093-.152.157-.325.192-.519l1.556.007a2.903 2.903 0 01-.945 1.793 3.024 3.024 0 01-.959.576c-.369.14-.787.21-1.253.21-.649 0-1.229-.147-1.74-.44a3.126 3.126 0 01-1.208-1.276c-.293-.556-.44-1.23-.44-2.02 0-.794.15-1.468.448-2.025.298-.556.703-.98 1.214-1.27a3.404 3.404 0 011.726-.441c.421 0 .812.059 1.172.177.362.119.683.292.962.519.28.225.507.5.682.827.178.327.291.701.34 1.122z","fill":"#000"}})])
          )
        }
      }
    